/**
 * ANM22 Pay Plugin for Vue.js
 */

import functions from './functions';
import tableClasses from './tableClasses';
import icons from './icons';

export default {
    install (Vue, options) {
        if(Vue.prototype.$anm22 == null) {
            Vue.prototype.$anm22 = {
                tableClasses: {},
                icons: {}
            };
        }
        Object.assign(Vue.prototype.$anm22, {
            ...functions
        });
        Object.assign(Vue.prototype.$anm22.tableClasses, tableClasses);
        Object.assign(Vue.prototype.$anm22.icons, icons);
    }
}